// extracted by mini-css-extract-plugin
module.exports = {"map":"BaseMap_map__3ks6P"};